export default "__VITE_ASSET__C3YD$93j__"